import React, { useEffect } from 'react';
import { Layout } from 'element';
import { useRoute } from 'hooks';
import { useSelector } from 'react-redux';
import { privateRoutes } from 'routes';
import { getIsDutiesAvailable } from 'state/Account';
import { RosterSettingsHeader } from '../../components/RosterSettingsHeader';
import { DutiesByLocation } from './DutiesByLocation';

function Duties() {
  const route = useRoute();
  const isDutiesAvailable = useSelector(getIsDutiesAvailable);

  useEffect(() => {
    if (!isDutiesAvailable) {
      route.goTo(privateRoutes.settings.routes.rosterSettings.routes.general.path);
    }
  }, [isDutiesAvailable, route]);

  if (!isDutiesAvailable) {
    return null;
  }

  return (
    <>
      <Layout.Header>
        <RosterSettingsHeader activeTab="duties" />
      </Layout.Header>
      <Layout.Content>
        <DutiesByLocation />
      </Layout.Content>
    </>
  );
}

export default Duties;


